import { MenuPoint } from '@agilox/ui-common';
import { lifecycleMenuPoints } from './menupoints';

export const mobileMenuPoints: MenuPoint[] = [
	lifecycleMenuPoints.dashboard,
	{
		name: 'menu.menu',
		url: '',
		icon: 'menu_hamburger',
		roles: [],
		submenus: [
			lifecycleMenuPoints.dashboard,
			lifecycleMenuPoints.replay,
			lifecycleMenuPoints.remote,
			lifecycleMenuPoints.help,
			lifecycleMenuPoints.logout,
		],
	},
];
